import PhoneCalls from './PhoneCalls';

export { PhoneCalls};



// WEBPACK FOOTER //
// src/modules/screens/settings/PhoneCalls/components/index.js